import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";

const KEY = "cookie_banner_dismissed";

export function CookieBanner() {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    setMounted(true);
    try {
      if (localStorage.getItem(KEY) !== "true") setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setLeaving(true);
    try {
      localStorage.setItem(KEY, "true");
    } catch {
      // ignore
    }
    setTimeout(() => setVisible(false), 300);
  };

  if (!mounted || !visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: "#E8E1D3",
        borderTop: "1px solid #8B1E1E",
        transform: leaving ? "translateY(100%)" : "translateY(0)",
        transition: "transform 300ms ease-out",
      }}
    >
      <div
        className="mx-auto flex w-full max-w-[1200px] flex-col items-stretch gap-4 px-4 py-4 md:flex-row md:items-center md:justify-between md:gap-8 md:px-8 md:py-6"
      >
        <div className="min-w-0 flex-1">
          <p
            className="text-ink"
            style={{
              fontFamily: '"Cormorant Garamond", serif',
              fontSize: "16px",
              lineHeight: 1.5,
            }}
          >
            We use cookies to keep you signed in and remember your progress. We don't
            use ads or trackers.
          </p>
          <Link
            to="/privacy"
            className="mt-2 inline-block italic text-burgundy underline decoration-burgundy/40 decoration-1 underline-offset-4 transition-all hover:decoration-2 hover:decoration-burgundy"
            style={{
              fontFamily: '"Cormorant Garamond", serif',
              fontSize: "14px",
            }}
          >
            Read the privacy policy
          </Link>
        </div>
        <div className="shrink-0">
          <button
            type="button"
            onClick={dismiss}
            className="w-full bg-burgundy text-paper uppercase transition-colors hover:bg-[#6B1717] md:w-auto"
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: "14px",
              fontWeight: 700,
              letterSpacing: "0.05em",
              padding: "14px 28px",
              borderRadius: 0,
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
